/*global angular,env*/
'use strict';

angular.module('MrDWebApp').controller('MenuCtrl', function ($scope, $rootScope, $stateParams, $timeout, $q, menu, item,
                                                             $filter, $state, $previousState,
                                                             $cookies, storage, $window, $document, $http) {

  var _mc = this;

  function getRestaurantFromLandingItemsById(restaurantId, ll) {
    var restaurant = null;
    var keepGoing = true;
    angular.forEach(ll, function (item) {
      angular.forEach(item.tiles, function (tile) {
        if (keepGoing && tile.type === 'restaurant' && restaurantId === tile.payload.id) {
          restaurant = tile.payload;
          keepGoing = false;
        }
      });
    });
    return restaurant;
  }

	_mc.loadMenu = function(){
		menu.$promise.then(function (menuData) {
	
			$scope._rc.track('restaurant_details_page','view_restaurant_menu');
			$window._adjustEvent('1tvys8'); //viewed_restaurant_details
	
			if (menuData.active_buy_1_get_1_free) {
				$scope._rc.cart.restaurant.active_buy_1_get_1_free = menuData.active_buy_1_get_1_free;
			}
			if (menuData.active_meal_deal) {
				$scope._rc.cart.restaurant.active_meal_deal = menuData.active_meal_deal;
			}
	
			//console.log('menuData', menuData.featured_items);
			if (menuData.hasOwnProperty('featured_items')) {
				_mc.featured = [];
				menuData.featured_items.forEach(function(feat){
					if (feat.type === 'featured_item' && feat.items) {
						feat.items.forEach(function(fi){
							var item = menuData.sections.reduce(function(acc,section){
								return acc? acc : section.items.find(function(itm){
	
									var lowestDiscount = false;
	
									itm.variants.forEach(function(variant){
										if (
												variant.percentage_discount &&
												(!lowestDiscount || lowestDiscount > variant.price)
											) {
											itm.percentage_discount = variant.percentage_discount;
											lowestDiscount = variant.price;
										}
									});
	
									return itm.id === fi;
								});
							}, null);
							//console.log('item',item);
							if (item) _mc.featured.push(item);
						});
					}
				});
			}
	
			//GW: I could reduce the following procedure, but not without adding complexity
			if (menuData.sections) menuData.sections.forEach(function(section){
				if (section.items) section.items.forEach(function(item){
					if (item.variants) item.variants.forEach(function(variant){
	
						//  OPTIONS
						if (variant.option_indices) variant.options = variant.option_indices.map(function(index){
							var option = Object.assign({}, menuData.options[index]); //clone option and its items
							option.items = option.items.map(function(item){ return Object.assign({}, item); });
							return option;
						});
	
						//  EXTRAS
						if (variant.extra_indices) variant.extras = variant.extra_indices.map(function(index){
							var extra = Object.assign({}, menuData.extras[index]); //clone extra and its items
							extra.items = extra.items.map(function(item){ return Object.assign({}, item); });
							return extra;
						});
	
						//  ADDONS
						if (variant.addon_indices) variant.addons = variant.addon_indices.map(function(index){
							var addon = Object.assign({}, menuData.addons[index]); //clone addon and its items
							//console.log("ADDON PRICE", addon.items.map(function(item){return item.price;}), addon.price_modifier, variant.price)
							if (addon.items) addon.items = addon.items.map(function(item){
								item = Object.assign({}, item);
	
								//  ADDON OPTIONS
								if (item.option_indices) item.options = item.option_indices.map(function(index){
									var option = Object.assign({}, menuData.options[index]); //clone option and its items
									if (option.items) option.items = option.items.map(function(item){ return Object.assign({}, item); });
									return option;
								});
	
								//  ADDON EXTRAS
								if (item.extra_indices) item.extras = item.extra_indices.map(function(index){
									var extra = Object.assign({}, menuData.extras[index]); //clone extra and its items
									if (extra.items) extra.items = extra.items.map(function(item){ return Object.assign({}, item); });
									return extra;
								});
	
								return item;
							});
							return addon;
						});
					}); //forEach item variant
				}); //forEach section item
			}); //forEach section
	
	
			_mc.split_menu_sections();
			_mc.isLoading = false;
			_mc.checkReady();
	
	
		});
	};

	// eg. http://localhost/order/restaurant/[restaurant_id]/menu/[menu_id]?preview=1&lat=-34.0677091&lon=18.4540099&st=Lente+Street
	// Group eg. http://localhost/order/restaurant/0/menu/[menu_id]?preview=1
	$scope.isPreview = $stateParams.preview === '1';

  // console.log('setting global variable  $scope._rc.cart.restaurant.id: '+ $scope._rc.cart.restaurant.id);
  // console.log('setting global variable  $scope._rc.cart.restaurant.menu_id: '+ $scope._rc.cart.restaurant.menu_id);

  var restaurantId = parseInt($stateParams.restaurantID);
  //if the user manually types in the url in the browser and does not click on the tile

	if ($scope.isPreview) {
		if (restaurantId === 0) { // group menu preview (butt ugly)
			_mc.loadMenu();
		} else {
			var lat = $stateParams.lat;
			var lon = $stateParams.lon;
			var st = $stateParams.st;
			$http.get(env.apiURL + 'landing-items?latitude='+lat+'&longitude='+lon+'&street_name='+st).then(res => {
				// console.log('LL',res.data.items)
				_mc.restaurant = getRestaurantFromLandingItemsById(restaurantId, res.data.items);
				_mc.loadMenu();
			}, er => {
				console.error(er);
				window.alert('Preview failed. See log for more details.');
			});
		}
	} else {
		$scope._rc.cart.restaurant.id = parseInt($stateParams.restaurantID, 10);
		// MRDFI-92
		$scope._rc.cart.restaurant.menu_id = parseInt($stateParams.menuID);
	
		_mc.restaurant = $scope._rc.variables.restaurant;
		if( restaurantId !== _mc.restaurant.id){
			_mc.restaurant = getRestaurantFromLandingItemsById(restaurantId, storage.get('restaurants'));
			if (_mc.restaurant === null){
				console.log('GOING HOME: _mc.restaurant === null');
				if (window.env.domainSplit) window.location.href = '/'; else $state.go('home');
			} else if (parseInt($stateParams.menuID) !== _mc.restaurant.menu_id){
				console.log('GOING HOME: parseInt($stateParams.menuID) !== _mc.restaurant.menu_id');
				if (window.env.domainSplit) window.location.href = '/'; else $state.go('home');
			}
			else{
					$scope._rc.title_tag = _mc.restaurant.name;
			}
		}
		_mc.loadMenu();
	}

  $previousState.memo('caller');

  $scope._rc.bodyClass = 'html-menu';

  _mc.isLoading = true;

  _mc.ready = false;
  _mc.menu = menu;

  _mc.item = item;
  _mc.menu_sections_a = [];
  _mc.menu_sections_b = [];

  _mc.itemVisible = false;
  _mc.menuSearchText = {
    name: ''
  };
  _mc.expandOverride = false;

  _mc.itemOverlayState = false;
  _mc.itemOverlayItem = null;
  _mc.activeVariant = null;
  _mc.tempCartItem = {};
  _mc.allLocalGroupsTemplate = {
    options: [],
    extras: [],
    addons: []
  };
  _mc.allLocalGroups = angular.copy(_mc.allLocalGroupsTemplate);
  _mc.allLocalGroupsValidation = [];

  // $scope._rc.cart.restaurant.id = parseInt($stateParams.restaurantID, 10);
  //
  // // MRDFI-92
  // $scope._rc.cart.restaurant.menu_id = parseInt($stateParams.menuID);

  storage.set('mrd-web-variables', $scope._rc.variables);


  $scope._rc.windowWidth =  $window.innerWidth;

  angular.element($window).bind('resize', function () {

    if ($window.innerWidth !== $scope._rc.windowWidth) {
      $scope._rc.windowWidth = $window.innerWidth;
      _mc.split_menu_sections();
    }

    $scope.$apply();
  });

  $document.bind('keyup', function(event) {
    if(event.code === 'Escape' && _mc.selectedItem){
      _mc.closeItem();
      $scope.$apply();
    }
  });


  // console.log('menu.js, commenting out call to promise.. ');
  // console.log('menu.js, passing the clicked tile ');

  /* Restaurant Item Click Logic */
  _mc.closeItem = function(){
    ////console.log('close item?')
    _mc.selectedItem = null;
    _mc.tempCartItem = {};
    _mc.itemVisible = false;
    $rootScope.$broadcast('overlay:hide');
  };

  _mc.copySectionName = function(section_name){
    $scope._rc.garbage.itemOverlayItemSection = angular.copy(section_name);
  };

  _mc.checkIfVariantsAreSoldOut = function(variants){
    var soldout = true;
    for(var i = 0; i < variants.length; i++){
      if(variants[i].availability.status !== 'sold_out'){
        soldout = false;
      }
    }
    return soldout;
  };

  _mc.checkReady = function(){
    //console.log('allLocalGroups', _mc.allLocalGroups);
    var check = false;
    var double_check = false;
    var soldout_parent_check = false;
    //console.log('_mc.allLocalGroupsValidation',_mc.allLocalGroupsValidation)
    //console.log('_mc.activeVariant',_mc.activeVariant)
    if(_mc.allLocalGroupsValidation.length > 0){
      for(var i = 0; i < _mc.allLocalGroupsValidation.length; i++){
        check = true;
        if(_mc.allLocalGroupsValidation[i].valid === false){
          i = 999; // skip
          ////console.log('skip, false found')
          check = false;
        } else {
          check = true;
        }
      }
    } else {
      check = true;
    }


    if(_mc.activeVariant === null){
      double_check = false;
    } else {
      double_check = true;
    }

    if(_mc.selectedItem && _mc.selectedItem.availability.status === 'sold_out'){
      soldout_parent_check = false;
    } else {
      soldout_parent_check = true;
    }

    ////console.log('check',check,double_check);
    if(check && double_check && soldout_parent_check){
      _mc.ready = true;
    } else {
      _mc.ready = false;
    }
    ////console.log('mc.ready',_mc.ready);
  };

  _mc.checkValidity = function(localGroupValidation,min){
    if(min === 0){
      localGroupValidation.valid = true;
    }
  };

  _mc.menuSearchChange = function(){
    if(_mc.menuSearchText.name){
      _mc.expandOverride = true;
    } else {
      _mc.expandOverride = false;
    }
  };

  _mc.split_menu_sections = function(){
    _mc.menu_sections_a = [];
    _mc.menu_sections_b = [];
    if (!menu.sections) return;

    if($scope._rc.windowWidth >= 980){
      for (var i = 0; i < menu.sections.length; i++) {
        if (i%2 === 0){
          if (menu.sections[i].header_styling === 'bold') { // add special to top
            _mc.menu_sections_a.unshift(angular.copy(menu.sections[i]));
          } else {
            _mc.menu_sections_a.push(angular.copy(menu.sections[i]));
          }
        } else {
          if (menu.sections[i].header_styling === 'bold') { // add special to top
            _mc.menu_sections_b.unshift(angular.copy(menu.sections[i]));
          } else {
            _mc.menu_sections_b.push(angular.copy(menu.sections[i]));
          }
        }
      }
    } else {
      // _mc.menu_sections_a = angular.copy(angular.copy(menu.sections));
      for (var j = 0; j < menu.sections.length; j++) {
        if (menu.sections[j].header_styling === 'bold') { // add special to top
          _mc.menu_sections_a.unshift(angular.copy(menu.sections[j]));
        } else {
          _mc.menu_sections_a.push(angular.copy(menu.sections[j]));
        }
      }
      _mc.menu_sections_b = [];
    }
  };

  _mc.resetToDefaults = function () {
    _mc.itemOverlayItem = null;
    _mc.activeVariant = null;
    _mc.allLocalGroups = angular.copy(_mc.allLocalGroupsTemplate);
    _mc.tempCartItem = {};
    _mc.selectedItem = null;
  };

  _mc.isActive = function (parent, item) {
    ////console.log('_mc_isActive', parent.localGroup)
    ////console.log(item);
    if(parent.localGroup){
      if ($filter('filter')(parent.localGroup, item).length > 0) {
        return true;
      } else {
        return false;
      }// Found first occurance
    } else {
      return false;
    }

  };

  _mc.checkForModifierPrice = function(item){
    var lowestPricesOverall = []; //each variant will have a lowest possible price, each will be represented at an index
    var highestPricesOverall = [];

    var lowest_variant_price = Number.MAX_SAFE_INTEGER;
    var lowest_variant_old_price = 0;

    if (item.variants) item.variants.forEach(function(variant){
      var lowestPrices = []; //all the lowest prices of a variant
      var highestPrices = [];

      if (variant.old_price) {
        if (variant.price < lowest_variant_price) {
          lowest_variant_price = variant.price;
          lowest_variant_old_price =  variant.old_price;
        }
      }

      // EXTRAS
      if (variant.extras) variant.extras.forEach(function(extras){
        if (!extras.items.length || !extras.minimum_select) {
          lowestPrices.push(0);
          return; //continue
        }

        var lowestPricedItems = extras.items.concat().sort(function(a,b){return a.price-b.price;}).splice(0,extras.minimum_select).map(function(i){return i.price;});
        lowestPrices.push(lowestPricedItems.reduce(function(a,v){return a+v;}, 0));

        var highestPricedItems = extras.items.concat().sort(function(b,a){return a.price-b.price;}).splice(0,extras.minimum_select).map(function(i){return i.price;});
        highestPrices.push(highestPricedItems.reduce(function(a,v){return a+v;}, 0));
      });

      // ADD-ONS
      if (variant.addons) variant.addons.forEach(function(addon){
        if (!addon.price_modifier) { //these are pricesless addon items
          lowestPrices.push(0); //GW: actually sum of all prices >0
          return; //continue
        } else if (!addon.items || !addon.items.length || !addon.minimum_select) {
          lowestPrices.push(0);
          return; //continue
        }

        //get the list of lowest prices based on required minimum selection
        var lowestPricedItems = addon.items.concat().sort(function(a,b){return a.price-b.price;}).splice(0,addon.minimum_select).map(function(i){return i.price;});
        var highestPricedItems = addon.items.concat().sort(function(b,a){return a.price-b.price;}).splice(0,addon.minimum_select).map(function(i){return i.price;});

        //queue the lowest variant price for consideration for lowest item price
        //TODO: include required addon extras
        lowestPrices.push(window.getAddonGroupSubTotal(lowestPricedItems, addon.price_modifier, variant.price));
        highestPrices.push(window.getAddonGroupSubTotal(highestPricedItems, addon.price_modifier, variant.price));
      });

      //get the sum of required prices
      lowestPricesOverall.push(variant.price + (lowestPrices.length? lowestPrices.reduce(function(a,v){return a+v;}, 0) : 0));
      highestPricesOverall.push(variant.price + (highestPrices.length? highestPrices.reduce(function(a,v){return a+v;}, 0) : 0));
    });

    //return the lowest variant price as lowest item price
    var low = lowestPricesOverall.reduce(function(a,v){return a>v?v:a;}, lowestPricesOverall[0]);
    var high = highestPricesOverall.reduce(function(a,v){return a>v?a:v;}, highestPricesOverall[0]);
    //console.log('PRICE', item.name, low, high);
    item._fromHeading = low !== high; // `from` caption above item price
    if (lowest_variant_old_price) {
      item._fromHeading = item._fromHeading && (lowest_variant_price === low); // show from if lowest menu deal is equals lowest price
      item._old_price = lowest_variant_old_price;
      return lowest_variant_price;
    }
    return low;
  };

  _mc.itemTotals = function () {
    ////console.log('totals',_mc.tempCartItem);
    var local_sub_total = 0;
    var item = _mc.tempCartItem;

    if(item.options){
      for(var i = 0; i < item.options.length; i++){
        if(item.options[i].price){
          local_sub_total += item.options[i].price;
        }
      }
    }
    if(item.extras){
      for(var ii = 0; ii < item.extras.length; ii++){
        if(item.extras[ii].price){
          local_sub_total += item.extras[ii].price;
        }
      }
    }
    if(item.addons){
      for(var iii = 0; iii < item.addons.length; iii++){
        if(item.addons[iii].price){
          local_sub_total += item.addons[iii].price;
        }
      }
    }

    var total = item.quantity * local_sub_total;
    var increments = item.quantityPay + item.quantityFree;
    var payFactor = item.quantityPay / increments;
    var quantityDiscount = Math.floor(item.quantity / increments) * increments;
    var quantityFullPrice = item.quantity % increments;
    total += quantityDiscount * item.price * payFactor;
    total += quantityFullPrice * item.price;

    return total;
  };

  _mc.increment = function (direction) {
    var inc = _mc.tempCartItem.quantityFree + _mc.tempCartItem.quantityPay;
    if (direction === 'up' && _mc.tempCartItem.quantity < 99) {
      _mc.tempCartItem.quantity += inc;
    }
    if (direction === 'down' && _mc.tempCartItem.quantity > inc) {
      _mc.tempCartItem.quantity -= inc;
    }
  };


  /**
   * Called when a user taps on a menu item.
   *
   * @param section Section parent to the selected item, originates from `menu_sections_a` or `menu_sections_b`
   * @param item The item selected
   */
  _mc.menuItemClick = function(section,item){
    //console.log($scope._rc.variables.restaurant.id);
    //console.log(_mc.restaurant.id);
    // reload variables from !

    $scope._rc.variables = angular.copy(storage.get('mrd-web-variables'));

    if(!$scope.isPreview && (!_mc.restaurant.open || !_mc.restaurant.online)){
      // Thou shall not pass...
      $rootScope.$broadcast('global_message:show',  {
        'name': 'restaurant_offline',
        'for_state' : 'menu',
        'error' : {
          'friendly_message': _mc.restaurant.name + ' will be back in action soon.'
        },
        'confirm' : {
          'title': 'Offline for now!',
          //'message' : _mc.restaurant.name + ' will be back in action soon.',
          'label': 'Okay, got it!',
          'action' : 'close',
          'value' : true,
          'value_object': null
        },
        'deny' : {
          'label': 'Back to Restaurant list',
          'action' : 'redirect',
          'value' : 'location',
          'value_object': $scope._rc.variables.restaurant
        }
      });
    } else if (!$scope.isPreview && _mc.restaurant.id !== $scope._rc.variables.restaurant.id) {
      // Thou are trying to add from another restaurant... sneaky...
      $rootScope.$broadcast('global_message:show',  {
        'name': 'selected_from_other_restaurant',
        'for_state' : 'menu',
        'error' : {
          'friendly_message': 'Selecting food from a different restaurant will empty your current cart.'
        },
        'confirm' : {
          'label': 'Clear Cart and Continue',
          'action' : 'redirect',
          'value' : 'menu',
          'value_object': _mc.restaurant  //curation
        },
        'deny' : {
          'label' : 'Back to Restaurant Menu',
          'action' : 'redirect',
          'value' : 'menu',
          'value_object' : _mc.restaurant
        }
      });

    } else {
      $scope._rc.track('restaurant_details_page','view_item');

      //_mc.featured(section.name);
      _mc.selectedItem = item;
      _mc.initTempCartItem();


      // Give the item a descriotion (name) from the item name
      _mc.updateTempCartItem('description', item.name); // Eish

      // Check first if this is sold out.
      // //console.log(_mc.selectedItem.variants[0]);

      // Do not select first variant if sold out...
      for(var i = 0; i < _mc.selectedItem.variants.length; i++){
        if(_mc.selectedItem.variants[i].availability.status === 'sold_out') continue;
        _mc.activeVariant = _mc.selectedItem.variants[i];
        break;
      }
      if (!_mc.activeVariant) return;

      _mc.variantSelect2(_mc.activeVariant); // Auto Select it...
    //console.log'acv', _mc.activeVariant)


      // Clean the items selected!!
      angular.forEach(_mc.activeVariant.options, function(value){
        angular.forEach(value.items, function(item_value) {
          delete item_value.selected;
        });
      });
      // Clean the items selected!!
      angular.forEach(_mc.activeVariant.extras, function(value){
        angular.forEach(value.items, function(item_value) {
          delete item_value.selected;
        });
      });
      // Clean the items selected!!
      angular.forEach(_mc.activeVariant.addons, function(value){
        angular.forEach(value.items, function(item_value) {
          delete item_value.selected;
        });
      });

      _mc.checkReady2();

      _mc.itemVisible = true;

      $rootScope.$broadcast('overlay:show', {
        'callback': function () {
          $timeout(function(){
            var itemHeight = document.getElementById('menu-item-popup-details').clientHeight;
            if(itemHeight < 600){
              angular.element(document.getElementById('html')).addClass('menu-item-static-button');
            } else {
              angular.element(document.getElementById('html')).removeClass('menu-item-static-button');
            }
          },1);
        }
      });


      //$state.go('item',{restaurantID: _mc.restaurant.id, menuID: _mc.restaurant.menu_id, itemID:item.id});
    }

  };

  /**
   * @param variant An variant of an item of a section of one of the split arrays (which contains clones of `menu` sections)
   */
  _mc.variantSelect2 = function (variant) {
    _mc.activeVariant = variant;
    /*
    _mc.activeVariant.options = []; // SETUP NEW FIELDS ON VARIANT TO RETAIN SANITY
    _mc.activeVariant.extras = [];  // SETUP NEW FIELDS ON VARIANT TO RETAIN SANITY
    _mc.activeVariant.addons = [];   // SETUP NEW FIELDS ON VARIANT TO RETAIN SANITY
    _mc.activeVariant.addonGroups = [];   // SETUP NEW FIELDS ON VARIANT TO RETAIN SANITY
    */

    _mc.tempCartItem.options = []; // CLEAR
    _mc.tempCartItem.extras = []; // CLEAR
    _mc.tempCartItem.addons = []; // CLEAR
    _mc.tempCartItem.addonGroups = []; // CLEAR

    if (variant.menu_deal_action === 'buy_1_get_1_free') {
      _mc.tempCartItem.quantityFree = 1;
      _mc.tempCartItem.quantity = _mc.tempCartItem.quantityFree + _mc.tempCartItem.quantityPay;
    } else {
      _mc.tempCartItem.quantityFree = 0;
      _mc.tempCartItem.quantity = 1;
    }


    //console.log('variantselect',_mc.activeVariant);
    //console.log('menu',_mc.menu);
    /*var i = 0;
    if(_mc.activeVariant.option_indices){
      for(i = 0; i < _mc.activeVariant.option_indices.length; i++){
        _mc.activeVariant.options.push(_mc.menu.options[_mc.activeVariant.option_indices[i]]);
      }
    }
    if(_mc.activeVariant.extra_indices){
      for(i = 0; i < _mc.activeVariant.extra_indices.length; i++){
        _mc.activeVariant.extras.push(_mc.menu.extras[_mc.activeVariant.extra_indices[i]]);
      }
    }
    if(_mc.activeVariant.addon_indices){
      for(i = 0; i < _mc.activeVariant.addon_indices.length; i++){
        _mc.activeVariant.addons.push(_mc.menu.addons[_mc.activeVariant.addon_indices[i]]);
      }
    }*/

    // Clean the items selected!!
    angular.forEach(_mc.activeVariant.options, function(value){
      angular.forEach(value.items, function(item_value) {
        delete item_value.selected;
      });
    });
    // Clean the items selected!!
    angular.forEach(_mc.activeVariant.extras, function(value){
      angular.forEach(value.items, function(item_value) {
        delete item_value.selected;
      });
    });
    // Clean the items selected!!
    angular.forEach(_mc.activeVariant.addons, function(value){
      angular.forEach(value.items, function(item_value) {
        delete item_value.selected;

        // Clean the items selected!!
        angular.forEach(item_value.options, function(value){
          angular.forEach(value.items, function(item_value) {
            delete item_value.selected;
          });
        });
        // Clean the items selected!!
        angular.forEach(item_value.extras, function(value){
          angular.forEach(value.items, function(item_value) {
            delete item_value.selected;
          });
        });
      });
    });

    _mc.updateTempCartItem('price', _mc.activeVariant.price);
    _mc.updateTempCartItem('old_price', _mc.activeVariant.old_price);
    _mc.updateTempCartItem('variant_name', _mc.activeVariant.name);
    _mc.updateTempCartItem('variant_id', _mc.activeVariant.id);
    _mc.updateTempCartItem('collect_only', (_mc.selectedItem.collect_only || false));
    //_mc.updateTempCartItem('description', _mc.activeVariant.description);

    _mc.checkReady2();


    //console.log('activeVariant POST',_mc.activeVariant);

  };
  // OLD V V V
  /*_mc.activeVariantSelect = function (variant) {
    content deleted
  };*/

  _mc.modifyPrice = function(itemPrice, modifier, variantPrice){
    if (modifier && modifier === 'DELTA_PRICES') {
      return Math.max(0, itemPrice - variantPrice);
    }
    return itemPrice;
  };

  /**
   * @param type 'option' | 'extra' | 'addon'
   * @param item An item form the group
   * @param group A the options/extras/addons group parent to the item
   */
  _mc.activeSelect2 = function (type, item, group) {

    //console.log('active Select|type|item|group',type,item,group);

    //console.log('item group rules: min:' + group.minimum_select + ' & max: ' + group.maximum_select);

    item.description = item.name; // Hack
    //if(group.price_modifier) { _mc.updateTempCartItem('price_modifier', group.price_modifier); } //GW: this is madness
    if(!group.minimum_select) { group.minimum_select = 0; }
    if(!group.maximum_select) { group.maximum_select = 99; }
  //console.log'no min?', group.minimum_select);

  //console.log'no max?', group.maximum_select);
    // MONDE
    if(item.selected === true) {
      item.selected = false;
    } else {


      // * WHAT THE ??? * @todo Fix
      if(group.minimum_select === 0 && group.maximum_select === 0) {
        item.selected = true;
      }
      else if(group.minimum_select === 1 && group.maximum_select === 1) {
        //DESELECT ALL
        for (var i = 0; i < group.items.length; i++) {
          delete group.items[i].selected;
        }
        item.selected = true;

      } else if (group.maximum_select <= $filter('filter')(group.items, {selected: true}).length) {

        //console.log('do nothing');

      } else {
        item.selected = true;
      }

      // Normal
      if (group.maximum_select <= $filter('filter')(group.items, {selected: true}).length) {
        //console.log('do nothing');
      } else {
        item.selected = true;
      }
    }

    var accumulateSelectedItems = function(accumulater,iterationObject){
      var ar = iterationObject.items
      .filter(function(i){return i.selected;})
      .map(function(i){return Object.assign({},i);});
      return accumulater.concat(ar);
    };

    _mc.tempCartItem.options = [];
    _mc.tempCartItem.extras = [];
    _mc.tempCartItem.addons = [];
    _mc.tempCartItem.addonGroups = [];
    var loop = 0;
    var items_count = 0;
    // OPTIONS
    if (_mc.activeVariant.options) for(loop = 0; loop < _mc.activeVariant.options.length; loop++){
      //console.log('loop final',_mc.activeVariant.options[loop]);
       // Just delete old shit..
      for(items_count = 0; items_count < _mc.activeVariant.options[loop].items.length; items_count++){
        //console.log('items',_mc.activeVariant.options[loop].items[items_count]);
        if(_mc.activeVariant.options[loop].items[items_count].selected === true){
          //console.log('this fucker is selected', _mc.activeVariant.options[loop].items[items_count]);
          _mc.tempCartItem.options.push(_mc.activeVariant.options[loop].items[items_count]);
        }
      }
    }

    // Extras
    if (_mc.activeVariant.extras) for(loop = 0; loop < _mc.activeVariant.extras.length; loop++){

      //console.log('loop final',_mc.activeVariant.extras[loop]);
      // Just delete old shit..
      for(items_count = 0; items_count < _mc.activeVariant.extras[loop].items.length; items_count++){
        //console.log('items extras',_mc.activeVariant.extras[loop].items[items_count]);
        if(_mc.activeVariant.extras[loop].items[items_count].selected === true){
          //console.log('this extras fucker is selected', _mc.activeVariant.extras[loop].items[items_count]);
          _mc.tempCartItem.extras.push(_mc.activeVariant.extras[loop].items[items_count]);
        }
      }
    }

    // ADDONS
    if (_mc.activeVariant.addons) for(loop = 0; loop < _mc.activeVariant.addons.length; loop++){
      //console.log('loop final',_mc.activeVariant.addons[loop]);
      var addon = _mc.activeVariant.addons[loop];
      var items = [];
      // Just delete old shit..
      for(items_count = 0; items_count < addon.items.length; items_count++){
        //console.log('items addons',addon.items[items_count]);
        if(addon.items[items_count].selected === true){
          //console.log('this addons fucker is selected', addon.items[items_count]);
          var addonItem = addon.items[items_count]; //REPURPOSING THE PARAMETER
          addonItem = Object.assign({}, addonItem); //clone

          // NOW MODIFY THE PRICE (this means the cart calculator must ignore DELTA_PRICE modfiers)
          //addonItem.originalPrice = addonItem.price;
          //addonItem.price = _mc.modifyPrice(addonItem.price, addon.price_modifier, _mc.activeVariant.price);

          //flatten options
          if (addonItem.options) addonItem.options = addonItem.options.reduce(accumulateSelectedItems, []);

          //flatten extras
          if (addonItem.extras) addonItem.extras = addonItem.extras.reduce(accumulateSelectedItems,[]);

          _mc.tempCartItem.addons.push(addonItem);
          items.push(addonItem);
        }
      }
      if (!items.length) continue; //no items, no group
      var addonGroup = Object.assign({}, addon); //clone group
      addonGroup.items = items;
      _mc.tempCartItem.addonGroups.push(addonGroup); //we need the add-on group price modifiers
    }


    _mc.checkReady2();

  };

  _mc.checkReady2 = function(){

    //console.log('run check 2');

    var check = true;
    var soldout_parent_check = false;

    _mc.ready = false;

    if(_mc.selectedItem && _mc.selectedItem.availability.status === 'sold_out'){
      soldout_parent_check = false;
    } else {
      soldout_parent_check = true;
    }


    // OPTIONS check
    angular.forEach(_mc.activeVariant.options, function(group){
      //console.log('check',group);
      if(!group.minimum_select) { group.minimum_select = 0; }
      if(!group.maximum_select) { group.maximum_select = 99; }

    //console.log'check min',group.minimum_select);
    //console.log'check max',group.maximum_select);

      var selectedCount = $filter('filter')(group.items, { selected: true }).length;
      if(selectedCount >= group.minimum_select && check){
        check = true;
      } else {
        check = false;
      }
    });

    // Extras check
    angular.forEach(_mc.activeVariant.extras, function(group){

      if(!group.minimum_select) { group.minimum_select = 0; }
      if(!group.maximum_select) { group.maximum_select = 99; }
    //console.log'check min',group.minimum_select);
    //console.log'check max',group.maximum_select);


      var selectedCount = $filter('filter')(group.items, { selected: true }).length;

      //console.log(selectedCount, group.minimum_select, check)
      if(selectedCount >= group.minimum_select && check){
        check = true;
      } else {
        check = false;
      }
    });

    // Addons check
    angular.forEach(_mc.activeVariant.addons, function(group){
      var min = group.minimum_select? group.minimum_select : 0;
      var max = group.maximum_select? group.maximum_select : 99;

      var selectedCount = group.items? $filter('filter')(group.items, { selected: true }).length : 0;
      if(selectedCount >= group.minimum_select && check){
        check = true;
      } else {
        check = false;
      }
      if (check && group.items) {
        var selectedItems = group.items.filter(function(item){return item.selected;});
        var c = selectedItems.length;

        if (c < min || max < c) {
          check = false;
        } else {
          selectedItems.forEach(function(item){

            if (check && item.options) check = item.options.reduce(function(check,option){
              var min = option.minimum_select? option.minimum_select : 0;
              var max = option.maximum_select? option.maximum_select : 99;

              c = option.items.filter(function(item){ return item.selected; }).length;
              return !check? false : (min <= c && c <= max);
            }, check);

            if (check && item.extras) check = item.extras.reduce(function(check,extra){
              var min = extra.minimum_select? extra.minimum_select : 0;
              var max = extra.maximum_select? extra.maximum_select : 99;

              c = extra.items.filter(function(item){ return item.selected; }).length;
              return !check? false : (min <= c && c <= max);
            }, check);

          });
        }
      }

    });

  //console.log'final check',check);
    if(check && soldout_parent_check) {
      _mc.ready = true;
    }



  };
  /* All SELECT Logic */
  _mc.activeSelect = function (type, parent, op_ex_ad, op_ex_ad_group) {
    //console.log('active Select', type, parent, op_ex_ad, op_ex_ad_group);
    op_ex_ad_group = op_ex_ad_group; // JSHint fix
    var removed = false;
    // Deselecting...
    for (var i = 0; i < parent.localGroup.length; i += 1) {
      if (parent.localGroup[i] === op_ex_ad) {
        parent.localGroup.splice(i, 1);
        removed = true;
      }
    }
    // Selecting...
    if (!removed) {
      var cant_select_anymore = false;
      if(parent.min >= 0 && parent.max === 1){
        parent.localGroup.length = 0; // Empty is. Don't use 'localGroup = []' as it created a new reference...
      }
      if(parent.min >= 1 && parent.max <= 99 && parent.localGroup.length === parent.max){
        cant_select_anymore = true; // Empty is. Don't use 'localGroup = []' as it created a new reference...
      }

      op_ex_ad.description = op_ex_ad.name; // Hack

      if(!cant_select_anymore){
        parent.localGroup.push(op_ex_ad);
      } else {
        /* @todo Add Event Tracking 'Max Cap! Deselect Others' */
      }

    }

    if(parent.localGroup.length >= parent.min) {
      parent.localGroupValidation.valid = true;
    } else {
      parent.localGroupValidation.valid = false;
    }

    _mc.checkReady(); // Do Form Final Check

    //console.log('all local groups', _mc.allLocalGroups);
    // UPDATE TOTALS
    _mc.updateTempCartItem('options', _mc.allLocalGroups.options);
    _mc.updateTempCartItem('extras', _mc.allLocalGroups.extras);
    _mc.updateTempCartItem('addons', _mc.allLocalGroups.addons);
  };

  _mc.initTempCartItem = function () {
    _mc.tempCartItem.description = '';
    _mc.tempCartItem.variant_id = 0;
    _mc.tempCartItem.variant_name = 'Init';
    _mc.tempCartItem.price = 0;
    _mc.tempCartItem.quantity = 1;
    _mc.tempCartItem.options = [];
    _mc.tempCartItem.extras = [];
    _mc.tempCartItem.addons = [];
    _mc.tempCartItem.addonGroups = [];
    _mc.tempCartItem.quantityFree = 0; // modify for buy x get y free
    _mc.tempCartItem.quantityPay = 1; // modify for buy x get y free
  };

  _mc.updateTempCartItem = function (field, value) {
    ////console.log('updateCartItem',field,value)
    //if (!value) { value = 'None'; }
    if(typeof value === 'object'){ // Always an array?
      _mc.tempCartItem[field] = [];
      for(var i = 0; i < value.length; i++){
        if(value[i].length > 0){
          for(var j = 0; j < value[i].length; j++){
            _mc.tempCartItem[field].push(value[i][j]);
          }
        }
      }
    } else {
      _mc.tempCartItem[field] = value;
    }
  };

  _mc.addToCartText = function(){
    if(_mc.selectedItem && _mc.selectedItem.availability.status === 'sold_out'){
      return 'Sold Out';
    }
    return 'Add To Cart';
  };

  _mc.addToCart = function () {

    $scope._rc.track('restaurant_details_page','add_to_cart');
    $window._adjustEvent('qr8o9p'); //add_to_cart

    // Add Item to Real Cart
    $scope._rc.cart.items.push(angular.copy(_mc.tempCartItem));
    $scope._rc.resetCartAge();
    delete $scope._rc.cart.menu; // possible info of abandoned order (cart -> checkout -> cart -> clear items ...)
    $scope._rc.cart.restaurant.id = parseInt($stateParams.restaurantID);
    $scope._rc.cart.restaurant.menu_id = parseInt($stateParams.menuID);
    $rootScope.$broadcast('cart:modified');
    storage.set('mrd-web-cart', $scope._rc.cart);
    _mc.resetToDefaults();
    _mc.closeItem();
    _mc.allLocalGroups = angular.copy(_mc.allLocalGroupsTemplate); // @todo Reset groups...

    //if there is a new promotion, we need it to calc/show the amount on the cart
    // $scope._rc.cart.restaurant.active_promotion = _mc.restaurant.active_promotion;
    // $scope._rc.cart.active_promotion = _mc.restaurant.active_promotion;
    console.log('Added item to cart with promotion? '+JSON.stringify($scope._rc.cart.restaurant.active_promotion));

    $state.go('menu', {
      menuID: $stateParams.menuID,
      restaurantID: $stateParams.restaurantID
    });
  };

  _mc.goToCart = function () {
    $window.scroll(0,0);


    // Possible to want to go to cart and you don't have the restaurant delivery details...
    ////console.log($scope._rc.variables);
    // if(!$scope._rc.variables.restaurant || !$scope._rc.variables.restaurant.deliverability_option){
    //   //console.log('problem boet');
    // }

    $state.go('cart');
  };

});
